import { atom } from "~/observers/jotai";
import { storageAuthKey } from "~/utils/storageKeys";

import type { Authentication } from "./types";

function readStoredSession(): Authentication | undefined {
	const raw = localStorage.getItem(storageAuthKey);
	if (!raw) return undefined;
	try {
		return JSON.parse(raw) as Authentication;
	} catch {
		return undefined;
	}
}

export const authenticationAtom = atom<Authentication | undefined>(
	readStoredSession(),
);
